<template>
    <div :style="{textAlign}">
      <span class="text-2xl font-family-8bit text-upper">{{ $t('loading') }}</span>
      <span class="animation-cubes"></span>
      <span class="animation-cubes"></span>
      <span class="animation-cubes"></span>
    </div>
</template>

<script>
export default {
  name: 'BaseLoading',
  props: {
    textAlign: { type: String, default: 'center' }
  }
}
</script>

<style scoped>
.animation-cubes {
  display: inline-block;
  background: black;
  width: 15px;
  margin-left: 4px;
  animation: jump-animation infinite 1.5s;
}
.animation-cubes:nth-child(2) {
  animation-delay: .4s;
}
.animation-cubes:nth-child(3) {
  animation-delay: .8s;
}
@keyframes jump-animation {
  0% { height: 0;}
  50% { height: 28px; }
  100% { height: 0; }
}
</style>
